const modalSupportTypo = {
  isNewDataTrue: 'Register New Support File',
  isNewDataFalse: 'Edit Support File'
};

export default modalSupportTypo;
